import React, { PropsWithChildren } from 'react';
import { Form, FormProps } from 'react-final-form';

import { useTranslation } from 'Modules/core/i18n';
import { Button2, Stack, Typography } from 'Modules/ui3';


export type FiltersModalComponentProps<TValues> = PropsWithChildren<FormProps<TValues>> & {
    resetValues?: TValues;
};

export const FiltersModalComponent = <TValues extends unknown, >({
    children, resetValues, ...props
}: FiltersModalComponentProps<TValues>) => {
    const { t } = useTranslation('filtersModalComponent');
    return (
        <Form<TValues> {...props}>
            {formProps => (
                <Stack
                    component='form'
                    spacing={8}
                    onSubmit={formProps.handleSubmit}
                    width={({ spacing }) => spacing(104)}
                    py={12}
                    px={8}
                    sx={{
                        backgroundColor: 'grayscale.shade0',
                        borderRadius: 8,
                    }}
                >
                    <Stack spacing={6}>
                        <Typography
                            color='grayscale.shade100'
                            variant='mediumHeader1'
                        >
                            {t('title')}
                        </Typography>
                        {children}
                    </Stack>

                    <Stack direction='row' spacing={5}>
                        <Button2
                            variantType='brand'
                            variant='primary'
                            type='submit'
                            disabled={formProps.hasValidationErrors}
                        >
                            {t('confirm')}
                        </Button2>
                        <Button2
                            variant='stroke'
                            onClick={() => formProps.form.restart(resetValues)}
                        >
                            {t('reset')}
                        </Button2>
                    </Stack>
                </Stack>
            )}
        </Form>
    );
};
